export default [
  {
    header: 'MAIN FUNCTIONS',
    action: 'read',
    resource: 'basic',
  },
  {
    title: 'Member List',
    route: 'member-list',
    icon: 'UsersIcon',
    // acl: {
    action: 'read',
    resource: 'pt',
    // },
  },
  {
    title: 'PT Schedule',
    route: 'calendar',
    icon: 'CalendarIcon',
    // acl: {
    action: 'read',
    resource: 'basic',
    action: 'read',
    resource: 'package',
    // },
  },
  {
    title: 'Class List',
    route: 'class-list',
    icon: 'TrelloIcon',
    // acl: {
    action: 'read',
    resource: 'staff',
    action: 'read',
    resource: 'class',

    // },
  },

  {
    header: 'Report',
    action: 'read',
    resource: 'basic',
  },
  {
    title: 'Daily Sales',
    icon: 'PieChartIcon',
    route: 'report',
    action: 'read',
    resource: 'manager',
  },
  {
    title: 'Transaction',
    icon: 'PieChartIcon',
    route: 'report-transacion',
    action: 'read',
    resource: 'manager',
  },
  {
    title: 'Personal Training',
    icon: 'PieChartIcon',
    route: 'report-personal-training',
    action: 'read',
    resource: 'basic',
  },
  {
    title: 'Unpay',
    icon: 'PieChartIcon',
    route: 'report-nonpay',
    action: 'read',
    resource: 'manager',
  },
  {
    header: 'Finance',
    action: 'read',
    resource: 'finance',
    action: 'read',
    resource: 'admin',


  },
  {
    title: 'Expenditure',
    route: 'expenditure',
    icon: 'ShoppingBagIcon',
    // acl: {
    action: 'read',
    resource: 'finance',
    action: 'read',
    resource: 'admin',
    // },
  },
  {
    title: 'Invoice',
    route: 'invoice',
    icon: 'DollarSignIcon',
    action: 'read',
    resource: 'finance',
    // acl: {
    action: 'read',
    resource: 'admin',

    // },
  },
  {
    header: 'System Config',
    action: 'read',
    resource: 'staff',
  },
  {
    title: 'Class Import',
    route: 'class-import',
    icon: 'TrelloIcon',
    // acl: {
    action: 'read',
    resource: 'staff',
    action: 'read',
    resource: 'class',

    // },
  },
  {
    title: 'User List',
    route: 'staff-list',
    icon: 'SmileIcon',
    // acl: {
    action: 'read',
    resource: 'admin',
    // },
  },
  {
    title: 'Room List',
    route: 'room-list',
    icon: 'TrelloIcon',
    // acl: {
    action: 'read',
    resource: 'admin',
    // },
  },
  {
    title: 'Product List',
    route: 'product-list',
    icon: 'TrelloIcon',
    // acl: {
    action: 'read',
    resource: 'admin',
    // },
  },
  {
    title: 'Package List',
    route: 'package-list',
    icon: 'TrelloIcon',
    // acl: {
    action: 'read',
    resource: 'admin',
    // },
  },
  /*
  {
    title: 'Report - Personal Training',
    icon: 'PieChartIcon',
    route: '/report/pt',
    action: 'read',
    resource: 'basic',
  },
  /*
  {
    title: 'Latest News',
    route: 'news-list',
    icon: 'MailIcon',
    // acl: {
    action: 'read',
    resource: 'basic',
    // },
  },

  {
    title: 'Config',
    route: 'system-config',
    icon: 'SettingsIcon',
    // acl: {
    action: 'read',
    resource: 'basic',
    // },
  },
  {
    title: 'Class List',
    route: 'class-list',
    icon: 'ListIcon',
    // acl: {
    action: 'read',
    resource: 'basic',
    // },
  },

  {
    title: 'Coupon',
    route: 'coupon-list',
    icon: 'GiftIcon',
    // acl: {
    action: 'read',
    resource: 'basic',
    // },
  },
  {
    title: 'Product List',
    route: 'product-list',
    icon: 'FolderIcon',
    // acl: {
    action: 'read',
    resource: 'basic',
    // },
  },
  {
    title: 'Center List',
    route: 'center-list',
    icon: 'HomeIcon',
    // acl: {
    action: 'read',
    resource: 'basic',
    // },
  },
  */
]
